import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { BsRootModule,ModalModule, BsModalRef } from 'ngx-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as $ from 'jquery';
import * as _ from 'lodash';
import { ToasterModule } from 'angular2-toaster';
import { LoggerModule, NgxLoggerLevel, NGXLogger } from 'ngx-logger';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { MaterialModule, MdNativeDateModule } from '@angular/material';
import { BusyModule } from 'angular2-busy';
import { HttpModule } from '@angular/http';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { TabsComponent } from './components/home/tabs.component';
import { HomeComponent } from './components/home/home.component';
import { NotificationsComponent } from './components/home/notifications.component';
import { LoginComponent } from './components/login/login.component';
import { DynamicTabsDirective } from './components/home/dynamic-tabs.directive';
import { dynamicModule } from './components/home/dynamic.module';
import { AuthGuard } from './guards/auth.guard';
import { APP_PROVIDERS } from './services/index';

import {StoreModule} from '@ngrx/store';
//import * as fromRootStore from './reducers';
import { reducers, metaReducers } from './reducers/index';
import {EffectsModule} from '@ngrx/effects';
import { MdFormFieldModule, MdInputModule } from '@angular/material';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        HomeComponent,
        NotificationsComponent,
        TabsComponent,
        DynamicTabsDirective
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        routing,
        BsRootModule,
        ModalModule.forRoot(),
        HttpModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule, MdNativeDateModule,
        dynamicModule,
        NgxDatatableModule,
        ToasterModule,
        BusyModule,
        StoreModule.forRoot(reducers, { metaReducers }),
        StoreDevtoolsModule.instrument({
            maxAge: 25 //  Retains last 25 states
        }),
		EffectsModule.forRoot([]),
        LoggerModule.forRoot({ serverLoggingUrl: '/api/logs/uiLogs', level: NgxLoggerLevel.DEBUG, serverLogLevel: NgxLoggerLevel.ERROR }),
        MdFormFieldModule,
        MdInputModule
    ],
    exports: [dynamicModule],
    entryComponents: [

    ],
    providers: [
        APP_PROVIDERS,
        AuthGuard,
        NGXLogger,
        BsModalRef
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/app.module.ts